import { getRequest, postRequest, deleteRequest, patchFileRequest, patchRequest } from "../helpers/fetchHandler"
import {
  DESTINATIONS_LOADING,
  DESTINATIONS_SUCCESS,
  DESTINATIONS_FAILED,
  DESTINATION_BY_ID_LOADING,
  DESTINATION_BY_ID_SUCCESS,
  DESTINATION_BY_ID_FAILED,
  CREATE_DESTINATION_LOADING,
  CREATE_DESTINATION_SUCCESS,
  CREATE_DESTINATION_FAILED,
  UPDATE_DESTINATION_LOADING,
  UPDATE_DESTINATION_SUCCESS,
  UPDATE_DESTINATION_FAILED,
  DELETE_DESTINATION_LOADING,
  DELETE_DESTINATION_SUCCESS,
  DELETE_DESTINATION_FAILED,
  DESTINATION_SELECTED,
  DESTINATION_UNSELECTED,
  EXAMPLE_DESTINATION_LOADING,
  EXAMPLE_DESTINATION_SUCCESS,
  EXAMPLE_DESTINATION_FAILED
} from "../constants/actionTypes"

export function fetchAllDestinations() {
  return async dispatch => {
    dispatch({ type: DESTINATIONS_LOADING })

    const url = "/api/v1/destinations"
    try {
      const response = await getRequest({ url, auth: true })
      dispatch({ type: DESTINATIONS_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: DESTINATIONS_FAILED, error })
      throw error
    }
  }
}

export const fetchDestinationById = id => async dispatch => {
  dispatch({ type: DESTINATION_BY_ID_LOADING })

  const url = `/api/v1/destinations/destination/${id}`
  try {
    const response = await getRequest({ url, auth: true })
    dispatch({ type: DESTINATION_BY_ID_SUCCESS, payload: response, meta: { id } })
    return response
  } catch (error) {
    dispatch({ type: DESTINATION_BY_ID_FAILED, error, meta: { id } })
    throw error
  }
}

export function createDestination(data) {
  return async dispatch => {
    dispatch({ type: CREATE_DESTINATION_LOADING })

    const url = "/api/v1/destinations"
    try {
      const response = await postRequest({ url, data, auth: true })
      dispatch({ type: CREATE_DESTINATION_SUCCESS, payload: response })
      return response
    } catch (error) {
      dispatch({ type: CREATE_DESTINATION_FAILED, error })
      throw error
    }
  }
}

export function updateDestinationWithFile(id, data) {
  return async dispatch => {
    dispatch({ type: UPDATE_DESTINATION_LOADING })

    const formData = new FormData()
    Object.entries(data).forEach(entry => {
      const [key, value] = entry
      if (typeof value === "object") {
        formData.append(key, value, value.name)
      } else {
        formData.append(key, value)
      }
    })

    const url = `/api/v1/destinations/${id}`
    return patchFileRequest({ url, data: formData, auth: true })
      .then(payload => dispatch({ type: UPDATE_DESTINATION_SUCCESS, payload }))
      .catch(error => {
        dispatch({ type: UPDATE_DESTINATION_FAILED, error })
        return Promise.reject(error)
      })
  }
}

export function updateDestination(id, data) {
  return async dispatch => {
    dispatch({ type: UPDATE_DESTINATION_LOADING })

    const url = `/api/v1/destinations/${id}`
    return patchRequest({ url, data, auth: true })
      .then(payload => dispatch({ type: UPDATE_DESTINATION_SUCCESS, payload }))
      .catch(error => {
        dispatch({ type: UPDATE_DESTINATION_FAILED, error })
        return Promise.reject(error)
      })
  }
}

export function deleteDestination(id) {
  return async dispatch => {
    dispatch({ type: DELETE_DESTINATION_LOADING })

    const url = `/api/v1/destinations/${id}/`
    return deleteRequest({ url, auth: true })
      .then(() => dispatch({ type: DELETE_DESTINATION_SUCCESS, payload: id }))
      .catch(error => {
        dispatch({ type: DELETE_DESTINATION_FAILED, error })
        return Promise.reject(error)
      })
  }
}

export function selectDestination(destinationId) {
  return dispatch => {
    dispatch({ type: DESTINATION_SELECTED, payload: destinationId })
    return Promise.resolve()
  }
}

export function unselectDestination() {
  return dispatch => {
    dispatch({ type: DESTINATION_UNSELECTED })
    return Promise.resolve()
  }
}

export function fetchExampleDestination() {
  return dispatch => {
    dispatch({ type: EXAMPLE_DESTINATION_LOADING })

    const url = "/api/v1/destinations/traveller/EXAMPLE"
    return getRequest({ url })
      .then(response => dispatch({ type: EXAMPLE_DESTINATION_SUCCESS, payload: response }))
      .catch(error => {
        dispatch({ type: EXAMPLE_DESTINATION_FAILED, error })
        return Promise.reject(error)
      })
  }
}
